import {
  type ExtendedExternalIntegrationType,
  ExtendedExternalIntegrationTypes,
} from "@src/appV2/ExternalIntegrations/types";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";
import { AttendanceOnDemandTimeclockCredentials } from "./AttendanceOnDemandTimeclockCredentials";
import { TimeclockComplianceCredentials } from "./TimeclockComplianceCredentials";
import { TimeclockPinPlusPasswordCredentials } from "./TimeclockPinPlusPasswordCredentials";
import { UKGReadyTimeclockCredentials } from "./UKGReadyTimeclockCredentials";
import { UKGTimeclockCredentials } from "./UKGTimeclockCredentials";

interface VendorTimeclockCredentialsProps {
  timeclockVendor: ExtendedExternalIntegrationType | undefined;
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  showPin?: boolean;
  onTogglePinVisibility: () => void;
  externalIdErrorPlaceholder?: string;
}

export function VendorTimeclockCredentials({
  timeclockVendor,
  register,
  errors,
  showPin,
  onTogglePinVisibility,
  externalIdErrorPlaceholder,
}: VendorTimeclockCredentialsProps) {
  switch (timeclockVendor) {
    case ExtendedExternalIntegrationTypes.UKG: {
      return (
        <UKGTimeclockCredentials
          register={register}
          errors={errors}
          externalIdErrorPlaceholder={externalIdErrorPlaceholder}
        />
      );
    }

    case ExtendedExternalIntegrationTypes.UKG_READY: {
      return (
        <UKGReadyTimeclockCredentials
          register={register}
          errors={errors}
          showPin={showPin}
          externalIdErrorPlaceholder={externalIdErrorPlaceholder}
          onTogglePinVisibility={onTogglePinVisibility}
        />
      );
    }

    case ExtendedExternalIntegrationTypes.ATTENDANCE_ON_DEMAND: {
      return (
        <AttendanceOnDemandTimeclockCredentials
          register={register}
          errors={errors}
          showPin={showPin}
          externalIdErrorPlaceholder={externalIdErrorPlaceholder}
          onTogglePinVisibility={onTogglePinVisibility}
        />
      );
    }

    case ExtendedExternalIntegrationTypes.TIMECLOCK_COMPLIANCE: {
      return <TimeclockComplianceCredentials register={register} errors={errors} />;
    }

    case ExtendedExternalIntegrationTypes.TIMECLOCK_COMPLIANCE_PIN_PLUS_PASSWORD: {
      return <TimeclockPinPlusPasswordCredentials register={register} errors={errors} />;
    }

    default: {
      return null;
    }
  }
}
